import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import type {State} from '../../../../reducers/types'
import {
  makeGetFavoriteSubProjectIds,
  makeGetDirectNotArchivedSubProjectIds,
  getProjectsReady,
} from '../../../../selectors'
import type {ProjectId} from '../../../../types'

import Subprojects from './Subprojects'

type OwnProps = {
  projectId: ProjectId
  onlyFavorites: boolean
}
type StateProps = {
  projectsReady: boolean
  notArchivedProjectIds: ReadonlyArray<ProjectId> | null | undefined
  favoriteProjectIds: ReadonlyArray<ProjectId>
}

const mapStateToProps: () => (state: State, props: OwnProps) => StateProps = () => {
  const getNotArchivedSubProjectIds = makeGetDirectNotArchivedSubProjectIds()
  const getFavoriteSubProjectIds = makeGetFavoriteSubProjectIds()
  return (state, {projectId}) => ({
    projectsReady: getProjectsReady(state),
    notArchivedProjectIds: getNotArchivedSubProjectIds(state, projectId),
    favoriteProjectIds: getFavoriteSubProjectIds(state, projectId),
  })
}

export default compose(connect(mapStateToProps))(Subprojects)
